import { Controller } from 'stimulus';

export default class EzController extends Controller {
  flagLoaded() {
    this.element.setAttribute('data-loaded', 'true');
  }

  featureEnabled(feature) {
    return document.body.getAttribute(`data-${feature}-feature`) === 'true';
  }

  splitTestEnabled(splitTest) {
    return document.body.getAttribute(`data-${splitTest}-test`) === 'true';
  }

  get csrfToken() {
    return document.querySelector('meta[name=csrf-token]') ? document.querySelector('meta[name=csrf-token]').content : null;
  }

  get csrfParam() {
    return document.querySelector('meta[name=csrf-param]') ? document.querySelector('meta[name=csrf-param]').content : null;
  }
}
